
export default{
    
    data(){
        return{
            
        }
    },
    methods:{
        getToken(){
            var token;
            const t = new Date();
            //console.log(t)
            var dd = String(t.getDate()).padStart(2, '0');
            var mm = String(t.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yy = t.getFullYear().toString().substr(-2)
            var hh=String(t.getHours()).padStart(2, '0');
            var nn= String(t.getMinutes()).padStart(2, '0');
            var ss=String(t.getSeconds()).padStart(2, '0');    
            
            token = this.swapChars(ss) + this.getChars(2) + this.swapChars(nn) + this.getChars(3) 
                + this.swapChars(hh) + this.getChars(4) + this.swapChars(yy) + this.getChars(5) 
                + this.swapChars(mm) + this.getChars(6) + this.swapChars(dd)
            //console.log(token)
            return token;
        },
        swapChars(instr){
            return instr.charAt(1) + instr.charAt(0)
        },
        getChars(num){
            var max = 2 + num
            var str = Math.random().toString(36).slice(2, max);
            return str
        }
    }

}


